"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashStore = void 0;
var mobx_1 = require("mobx");
var admin_1 = require("services/page/admin");
var app_1 = require("services/page/app");
var FlashStore = (function () {
    function FlashStore(moduleId, multiTab, isActView, flashModules) {
        var _this = this;
        this.moduleId = "";
        this.multiTab = false;
        this.isActView = false;
        this.currentPosition = 0;
        this.flashModules = [];
        this.activeIndex = 0;
        this.flashProducts = [];
        this.changePosition = function (nextPosition) {
            _this.currentPosition = nextPosition;
        };
        this.changeSelectedIndex = function (nextIndex) {
            _this.activeIndex = nextIndex;
        };
        this.refreshModule = function () { return __awaiter(_this, void 0, void 0, function () {
            var result_1, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, app_1.GetFrontModules({ moduleId: [this.moduleId] })];
                    case 1:
                        result_1 = _a.sent();
                        if (result_1 && result_1.mods && result_1.mods[this.moduleId]) {
                            mobx_1.runInAction("refresh flash module", function () {
                                _this.flashModules = result_1.mods[_this.moduleId].module
                                    .flashModules.filter(function (item) { return Number(item.endSpan) > 0; });
                            });
                        }
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.loadFlashModules = function (flashModules) {
            if (flashModules === void 0) { flashModules = []; }
            return __awaiter(_this, void 0, void 0, function () {
                var recentSession, idx, startFlag;
                var _this = this;
                return __generator(this, function (_a) {
                    recentSession = flashModules.find(function (item) { return item.state === admin_1.TActState.OnGoing; }) || flashModules[0];
                    idx = 0;
                    startFlag = false;
                    flashModules.forEach(function (item, index) {
                        if (item.state === admin_1.TActState.OnGoing &&
                            parseInt(recentSession.startSpan, 10) < parseInt(item.startSpan, 10)) {
                            recentSession = item;
                            idx = index;
                        }
                        if (parseInt(item.startSpan, 10) > 0 && !startFlag) {
                            startFlag = true;
                            setTimeout(function () {
                                _this.refreshModule();
                            }, parseInt(item.startSpan, 10) * 1000);
                        }
                    });
                    mobx_1.runInAction("set session list", function () {
                        _this.activeIndex = idx;
                        if (idx > 3) {
                            _this.currentPosition = idx - 3;
                        }
                    });
                    return [2];
                });
            });
        };
        this.loadFlashProducts = function (activeIds, poolIds, limit) { return __awaiter(_this, void 0, void 0, function () {
            var result_2, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, app_1.GetFlashProducts({
                                activeIds: activeIds,
                                poolIds: poolIds,
                                limit: limit
                            })];
                    case 1:
                        result_2 = _a.sent();
                        if (result_2 && result_2.fs) {
                            mobx_1.runInAction("set flash products", function () {
                                _this.flashProducts = result_2.fs;
                            });
                        }
                        return [3, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var newFlashModules = flashModules.filter(function (item) { return Number(item.endSpan) > 0; });
        this.moduleId = moduleId;
        this.multiTab = multiTab;
        this.isActView = isActView;
        this.flashModules = newFlashModules;
        this.loadFlashModules(newFlashModules);
        mobx_1.autorun(function () {
            var activeIds = _this.flashModules.map(function (item) { return item.pro.activeId; });
            var poolIds = _this.flashModules.map(function (item) { return item.pro.poolId; });
            if (_this.multiTab) {
                _this.loadFlashProducts(activeIds[_this.activeIndex] ? [activeIds[_this.activeIndex]] : undefined, poolIds[_this.activeIndex] ? [poolIds[_this.activeIndex]] : undefined, 200);
            }
            else {
                _this.loadFlashProducts(activeIds.filter(function (i) { return !!i; }), poolIds.filter(function (i) { return !!i; }), 30);
            }
        });
    }
    Object.defineProperty(FlashStore.prototype, "flashProductList", {
        get: function () {
            var _this = this;
            var flashModules = this.flashModules;
            if (this.multiTab) {
                flashModules = [this.flashModules[this.activeIndex]];
            }
            return this.flashProducts.map(function (item, index) {
                var currentModule = flashModules[index];
                return __assign(__assign({}, item), { state: currentModule && currentModule.state, activeId: currentModule && currentModule.pro && currentModule.pro.activeId, imgOnly: _this.multiTab
                        ? (currentModule && currentModule.isActView) || false
                        : _this.isActView, flashName: currentModule.flashName });
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], FlashStore.prototype, "currentPosition", void 0);
    __decorate([
        mobx_1.observable
    ], FlashStore.prototype, "flashModules", void 0);
    __decorate([
        mobx_1.observable
    ], FlashStore.prototype, "activeIndex", void 0);
    __decorate([
        mobx_1.observable
    ], FlashStore.prototype, "flashProducts", void 0);
    __decorate([
        mobx_1.computed
    ], FlashStore.prototype, "flashProductList", null);
    __decorate([
        mobx_1.action
    ], FlashStore.prototype, "changePosition", void 0);
    __decorate([
        mobx_1.action
    ], FlashStore.prototype, "changeSelectedIndex", void 0);
    __decorate([
        mobx_1.action
    ], FlashStore.prototype, "refreshModule", void 0);
    __decorate([
        mobx_1.action
    ], FlashStore.prototype, "loadFlashModules", void 0);
    __decorate([
        mobx_1.action
    ], FlashStore.prototype, "loadFlashProducts", void 0);
    return FlashStore;
}());
exports.FlashStore = FlashStore;
